/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

// Use environment variables instead of hardcoded values
export const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID ?? ''
export const publicAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? ''